import { makeStyles } from '@material-ui/core';
import React from 'react';
import NavMenu from '../NavMenu/NavMenu';

const useStyles = makeStyles({
    container: {
        display: "grid",
        gridTemplateRows: "min-content 1fr",
        height: "100%",
    },
    content: {
        overflow: "auto",
    }
});

export const Layout = props => {
    const styles = useStyles();
    return <div className={styles.container}>
        <NavMenu />
        <div className={styles.content}>
            {props.children}
        </div>
    </div>;
};
